import Breadcrumbs from 'components/breadcrumbs';
import { ResponsiveContainer } from 'components/atomic/atoms/responsive-container';
import { ListingActionButtons } from 'ui/action-buttons';
import type { HeaderSectionProps, ActionButtonData } from './types';
import styles from './header-section.module.scss';

export type { HeaderSectionProps, HeaderSectionData, ActionButtonData } from './types';
export { useHeaderSection } from './use-header-section';

/**
 * ListingHeaderSection
 *
 * Top header for listing pages - contains only breadcrumbs.
 * For v2, the action buttons are rendered separately via ListingActionButtonsSection.
 */
export function ListingHeaderSection({
  sectionId: _sectionId,
  show = 'all',
  data,
}: HeaderSectionProps) {
  const { breadcrumbs } = data;

  return (
    <ResponsiveContainer show={show} className={styles.container}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </ResponsiveContainer>
  );
}

export interface ListingActionButtonsSectionProps {
  sectionId?: string;
  show?: 'mobile' | 'tablet-large-up' | 'desktop' | 'all';
  actions: ActionButtonData;
}

/**
 * ListingActionButtonsSection
 *
 * Right-aligned action buttons (Like/Share) for listing pages.
 * Rendered as a separate section in v2 layout.
 * Shows at tablet-large+ (1024px) where sticky footer is NOT shown.
 */
export function ListingActionButtonsSection({
  sectionId,
  show = 'tablet-large-up',
  actions,
}: ListingActionButtonsSectionProps) {
  return (
    <ResponsiveContainer show={show} className={styles.actionsSection} data-section={sectionId}>
      <ListingActionButtons
        isLiked={actions.isLiked}
        onLikeClick={actions.onLikeClick}
        onShareClick={actions.onShareClick}
        likeLabel={actions.likeLabel}
        shareLabel={actions.shareLabel}
        copiedTooltip={actions.copiedTooltip}
        showCopiedTooltip={actions.showCopiedTooltip}
      />
    </ResponsiveContainer>
  );
}

export default ListingHeaderSection;
